import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'idp-skip-navigation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skip-navigation.component.html',
  styleUrls: ['./skip-navigation.component.scss']
})
export class SkipNavigationComponent {
  @Input() buttonLabel = '';
  @Output() focusFirstElEvent = new EventEmitter();

  focusFirstElement(): void {
    this.focusFirstElEvent.emit();
  }
}
